export default __webpack_public_path__ + "static/media/index-06.c913f358.png";